import { render, staticRenderFns } from "./TabDetails.vue?vue&type=template&id=29cc62d6&scoped=true&"
import script from "./TabDetails.vue?vue&type=script&lang=coffee&"
export * from "./TabDetails.vue?vue&type=script&lang=coffee&"
import style0 from "./TabDetails.vue?vue&type=style&index=0&id=29cc62d6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cc62d6",
  null
  
)

export default component.exports